import { initialState } from './reducer';
export var selectAppSettings = function (state) { return (state === null || state === void 0 ? void 0 : state.appSettings) || initialState; };
